import { Components, Theme } from '@mui/material';

export const MuiPaper = {
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundImage: 'none',
      backgroundColor: theme.palette.neutral.containerHighest,
      color: theme.palette.neutral.onSurface,
    }),
  }
} as Components<Theme>['MuiPaper'];
